import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom'

import { useAppState } from "./../../../state";

import FeatureFlagList from "./../FeatureFlagList"

// react-bootstrap components
import {
    Button,
    Card,
    Container,
    Row,
    Col,
    Spinner
} from "react-bootstrap";

//import "./FeatureFlagPage.scss";

async function DummySave(featureFlags) {
    var seed = Math.floor(Math.random() * (2 - 1 + 1)) + 1;
    var r = new Response()
    switch (seed) {
        case 1:
            return new Response(JSON.stringify({
                successful: true,
                ok: true,
                message: "Feature flags saved successfully"
            }), { status: 200, statusText: "OK" })
        case 2:
            return new Response(JSON.stringify({
                successful: false,
                ok: false,
                message: "Error saving feature flags"
            }), { status: 400, statusText: "Bad Request" })
        default:
            return new Response(JSON.stringify({ status: 500, successful: false, ok: false, message: "Unknown error" }), { status: 500, statusText: "Internal Server Error" })
    }
}

async function GetDummyData(id) {
    return JSON.stringify([
        {
            id: id,
            name: "test1",
            description: "Short description",
            startDate: new Date("2026-07-14T00:00:00.000-04:00"),
            endDate: null,
            enabled: true
        },
        {
            id: id + 1,
            name: "test2",
            description: "This is a very long description. It goes on for a while. There are details, instructions, and other information. It needs to be truncated or wrapped or both else the table will break",
            startDate: new Date("2026-07-14T00:00:00.000-04:00"),
            endDate: new Date("2026-07-18T20:00:00.000-04:00"),
            enabled: false
        },
        {
            id: id + 2,
            name: "test3",
            description: "Medium description, clarifying",
            startDate: new Date(),
            endDate: new Date(),
            enabled: true
        }
    ]);
}


function ToggleFeatureFlagsPage(props) {
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [saveSucceed, setSaveSucceed] = useState(false);

    const [errorMessage, setErrorMessage] = useState();
    const [cardCSSClass, setCardCSSClasses] = useState("");

    const [featureFlags, setFeatureFlags] = useState([]);

    const location = useLocation();

    const { user, app, onAppStateRefresh } = useAppState();

    let pageTitleContent;

    useEffect(() => {
        GetDummyData(5)
            .then(jsonString => JSON.parse(jsonString))
            .then(data => {
                setFeatureFlags(data);
            })
    }, []);

    const handleFlagToggleChange = (e) => {
        const flagId = e.currentTarget.getAttribute("id");
        let flags = featureFlags.map((f, _) => {
            if (f.id === parseInt(flagId)) {
                f.enabled = !f.enabled;
            }
            return f;
        });
        setFeatureFlags(flags);
    }

    const onSaveClick = async () => {
        try {
            setSaveSucceed(false);

            var seed = Math.floor(Math.random() * (100 - 1 + 1)) + 1;
            if (seed > 50) {
                setErrorMessage("error");
                setCardCSSClasses("form-group has-error");
            }
            else {
                setErrorMessage(undefined)
                setCardCSSClasses("");
            }
            setIsSaveLoading(true);

            const response = await DummySave(featureFlags);
            let responseBody = await response.json();
            switch (response.status) {
                case 400:
                    Object.keys(responseBody).map((key) => {
                        const fieldName = key.charAt(0).toLowerCase() + key.substring(1);
                        return fieldName;
                    })
                    break;
                case 200:
                    if (responseBody.successful === true) {
                        onAppStateRefresh();
                    }
                    setSaveSucceed(true);
                    break;
                default:
                    break;
            }
            setIsSaveLoading(false);
            return response.ok;
        }
        catch (e) {
            console.log(e);
        }
        setIsSaveLoading(false);
    }

    let errorMessageContent;
    if (errorMessage && errorMessage.length > 0) {
        errorMessageContent = (
            <Row>
                <Col className="d-flex justify-content-center">
                    <label className="error">{errorMessage}</label>
                </Col>
            </Row>
        );
    }

    let succeedMessageContent;
    if (saveSucceed) {
        succeedMessageContent = (
            <Row>
                <Col className="d-flex justify-content-center">
                    <label className="success">Feature flags saved successfully</label>
                </Col>
            </Row>
        );
    }

    let saveButtonContent = (
        <>
            <i className="fa fa-save"></i>
            Save
        </>
    )

    if (isSaveLoading) {
        saveButtonContent = (
            <>
                <Spinner animation="border" size="sm" />
                <span> Saving... </span>
            </>
        );
    }

    pageTitleContent = (
        <Card.Header>
            <p>Enable one or more feature flag(s) by turning on and off the switch near each flag.</p>
            <p>Note: Changing the feature flags will require you to log out from the application, close the browser window and all tabs, then open a new browser window for the new setting to get in effect</p>
        </Card.Header>
    )
    return (
        <Container fluid>
            <Card className={`table-with-switches bg-white border-0 ${cardCSSClass}`}>
                {/* {pageTitleContent}*/}
                <Card.Body>
                    <FeatureFlagList featureFlags={featureFlags} onFlagToggleChange={handleFlagToggleChange} />
                </Card.Body>
                <Card.Footer>
                    <Row>
                        <Col className="d-flex">
                            <Button className="mr-1" variant="primary" onClick={!isSaveLoading ? onSaveClick : null}>
                                {saveButtonContent}
                            </Button>
                        </Col>
                    </Row>
                    {errorMessageContent}
                    {succeedMessageContent}
                </Card.Footer>
            </Card>
        </Container>
    )
}

export default ToggleFeatureFlagsPage;